import { clearStoredZoneId } from './zone';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export const clearAuthStorage = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  clearStoredZoneId();
};

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);

export const getStoredUser = () => {
  const rawUser = localStorage.getItem(USER_KEY);
  if (!rawUser) {
    return null;
  }

  try {
    return JSON.parse(rawUser);
  } catch (error) {
    clearAuthStorage();
    return null;
  }
};

const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(normalized.length + ((4 - normalized.length % 4) % 4), '=');
  return atob(padded);
};

const decodeTokenPayload = (token) => {
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }

    const json = decodeBase64Url(parts[1]);
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token = getStoredToken()) => {
  if (!token) {
    return true;
  }

  const payload = decodeTokenPayload(token);
  if (!payload || !payload.exp) {
    return true;
  }

  return payload.exp * 1000 <= Date.now();
};

export const getLoginPath = (role) => {
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/cs')) {
    return '/cs/login';
  }
  return role === 'agent' ? '/agent/login' : '/login';
};

export const getPostLoginPath = (user) => {
  if (!user || user.role !== 'agent') {
    return '/';
  }

  const agentLevel = Number(user.agentLevel || user.agent_level || 0);
  if (agentLevel === 1 || user.agentType === 'promoter') {
    return '/agent/promoter-dashboard';
  }
  if (agentLevel === 2 || user.agentType === 'master' || user.isMasterAgent) {
    return '/agent/master-dashboard';
  }
  return '/agent/dashboard';
};

export const isAuthenticated = () => {
  const token = getStoredToken();
  if (!token) {
    return false;
  }

  if (isTokenExpired(token)) {
    clearAuthStorage();
    return false;
  }

  return true;
};
